import type { FerryBookingListFilter, FerryRouteFilter } from '../client';

/**
 * Query keys for @my/ferry-api. Everything hangs off `['ferry', …]` so one
 * prefix invalidation clears the lot. Filters are part of the key so a change
 * of route, window or status refetches rather than showing a stale list.
 */
export const ferryKeys = {
  all: ['ferry'] as const,
  carriers: () => ['ferry', 'carriers'] as const,
  routes: (carrierId: string | null, filter: FerryRouteFilter) =>
    ['ferry', 'routes', carrierId ?? 'all', filter] as const,
  vehicleTypes: (carrierId: string, isActive: boolean | undefined) =>
    ['ferry', 'vehicle-types', carrierId, isActive ?? 'all'] as const,
  sailings: (carrierId: string, routeCode: string, fromUtc: string, toUtc: string) =>
    ['ferry', 'sailings', carrierId, routeCode, fromUtc, toUtc] as const,
  capacityAll: ['ferry', 'capacity'] as const,
  capacity: (
    organisationId: string,
    carrierId: string,
    routeCode: string,
    fromUtc: string,
    toUtc: string,
  ) => ['ferry', 'capacity', organisationId, carrierId, routeCode, fromUtc, toUtc] as const,
  credentials: (organisationId: string, carrierId: string | undefined) =>
    ['ferry', 'credentials', organisationId, carrierId ?? 'all'] as const,
  bookingsAll: ['ferry', 'bookings'] as const,
  bookings: (organisationId: string, filter: FerryBookingListFilter) =>
    ['ferry', 'bookings', 'org', organisationId, filter] as const,
  booking: (id: string) => ['ferry', 'bookings', 'id', id] as const,
  bookingEvents: (id: string) => ['ferry', 'bookings', 'id', id, 'events'] as const,
};
